import { ApiProperty } from "@nestjs/swagger";
import { IsNotEmpty, IsOptional } from "class-validator";



export class AssetsSubCatagoryDTO {

    @ApiProperty()
    @IsOptional()
    assetsSubCatagoryId?: number;

    @ApiProperty()
    @IsNotEmpty({ message: "Code not be empty" })
    assetsSubCatagoryName: string;

    @ApiProperty()
    @IsNotEmpty({ message: "Code not be empty" })
    assetsCatagoryId: number;


    @ApiProperty()
    @IsNotEmpty({ message: "Name should not be empty" })
    isActive: boolean;


    @ApiProperty()
    @IsNotEmpty({ message: "Name should not be empty" })
    createdUser: string;

    @ApiProperty()
    @IsNotEmpty({ message: "Name should not be empty" })
    updatedUser: string;

    @ApiProperty()
    @IsOptional()
    assetsCatagoryName: string;

    @ApiProperty()
    @IsOptional()
    versionFlag: number;



}